import React from "react";
import "./css/Navbar.css"

export default function Navbar({ theme, toggleTheme }) {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <nav className="navbar">
            <div className="nav-container">
                <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    <ul className="nav">
                        <li><a href="/" onClick={closeMenu}>Home</a></li>
                        <li><a href="/about" onClick={closeMenu}>About</a></li>
                        <li><a href="/skills" onClick={closeMenu}>Skills</a></li>
                        <li><a href="/projects" onClick={closeMenu}>Projects</a></li>
                    </ul>
                </div>
                {/* Theme Toggle Switch */}
                <div className="theme-toggle">
                  <label className="switch">
                    <input type="checkbox" onChange={toggleTheme} checked={theme === 'dark'} />
                    <span className="slider round">
                      <div className="knob"></div>
                    </span>
                  </label>
                </div>
                <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
        </nav>
    );
}